import { BridgeNavigationalWatchAlarmSystem } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const BRIDGE_NAVIGATIONAL_WATCH_ALARM_SYSTEM_DATA_TAG = 'BridgeNavigationalWatchAlarmSystem';
export default class BridgeNavigationalWatchAlarmSystemParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.AT_SEA_BNWAS, FIXED_PROTOCOL_CONTENT_TYPE_IDS.AT_SEA_BNWAS, BRIDGE_NAVIGATIONAL_WATCH_ALARM_SYSTEM_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            alarmState: 'alarmState',
            freeText: 'freeText',
        };
    }
    createData(props) {
        return new BridgeNavigationalWatchAlarmSystem(props.alarmState, props.freeText);
    }
}
//# sourceMappingURL=BridgeNavigationalWatchAlarmSystemParser.js.map